export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_10.913a47e7.png";